























import {Component, Prop, Vue} from 'vue-property-decorator';
import moment from "moment";

import {IActiveShipment} from "@/models/StoreModels";
import { ShipmentLogic } from '@/models/ShipmentLogic';
import VueI18n from "vue-i18n";
import LocaleMessage = VueI18n.LocaleMessage;
import {ACTIVE_SHIPMENT_TYPE} from "@/constants/orders";

@Component({
  name: 'HistoryCardInfo',
  components: {
  },
})
export default class HistoryCardInfo extends Vue {
  @Prop()
  private userId!: number;

  @Prop()
  private shipment!: IActiveShipment;

  get creationDate(): string {
    return moment(this.shipment.created_at).format('DD-MM-YYYY, H:mma');
  }

  private get shipmentIsCompleted(): boolean {
    return ShipmentLogic.isCompleted(this.shipment);
  }

  private get getTitle(): LocaleMessage {
    switch (this.shipment.type) {
      case ACTIVE_SHIPMENT_TYPE.TYPE_CROSSTOWN_DELIVERY:
        return ShipmentLogic.userIsSender(this.shipment, this.userId) ? this.$t('cards.sendToAFriendOutgoing')
            : this.$t('cards.sendToAFriendIncoming');
      case ACTIVE_SHIPMENT_TYPE.TYPE_EXTERNAL_INCOMING:
        return this.$t('cards.externalIncoming');
      case ACTIVE_SHIPMENT_TYPE.TYPE_CLICK_COLLECT_INCOMING:
        return this.$t('cards.clickCollectIncoming');
      case ACTIVE_SHIPMENT_TYPE.TYPE_AMAZON_RETURNS_DELIVERY:
        return this.$t('cards.amazonReturns');
      case ACTIVE_SHIPMENT_TYPE.TYPE_PUBLIC_DELIVERY:
        return this.$t('cards.publicDelivery');
    }

    return this.$t('cards.unknownIncoming');
  }

  private get getText(): LocaleMessage {
    if (ShipmentLogic.isCompleted(this.shipment)) {
      return this.$t('status.completed');
    }

    if (ShipmentLogic.userIsSender(this.shipment, this.userId)) {
      if (ShipmentLogic.isAwaitingDropoff(this.shipment)) {
        return this.$t('cards.awaitingDropoff');
      }

      if (ShipmentLogic.isAwaitingPickup(this.shipment)) {
        return this.$t('cards.toBePickedUp');
      }

    } else {
      if (ShipmentLogic.needsDestination(this.shipment)) {
        return this.$t('cards.selectDestination');
      }


      if (ShipmentLogic.isAwaitingPickup(this.shipment)) {
        return this.$t('cards.awaitingPickup');
      }

    }

    return this.$t('cards.deliveryInProgress');
  }


}
